// Dashboard-scope constants.
// The UI scope uses short keys ("pa" / "intake"). The backend's CustomTagsView
// and ActionNeededStatusesView accept "prior_auth" / "intake" as the scope
// parameter — normalize once here so components don't re-implement the mapping.

export const SCOPE = Object.freeze({
  PA: "pa",
  INTAKE: "intake",
});

export const BACKEND_SCOPE = Object.freeze({
  [SCOPE.PA]: "prior_auth",
  [SCOPE.INTAKE]: "intake",
});

export const CLIENT_CONFIG_SECTION = Object.freeze({
  [SCOPE.PA]: "priorAuth",
  [SCOPE.INTAKE]: "intake",
});

export function toBackendScope(scope) {
  const mapped = BACKEND_SCOPE[scope];
  if (!mapped) throw new Error(`Unknown UI scope: ${scope}`);
  return mapped;
}

export function isValidScope(scope) {
  return scope === SCOPE.PA || scope === SCOPE.INTAKE;
}
